const orderDetailRoutes = [
  {
    path: "/order/add",
    name: "OrderAdd",
    component: () => import("../orderAdd/index.vue"),
    meta: {
      title: "订单新增",
    },
    hidden: true,
  },
  {
    path: "/order/detail/:id",
    name: "OrderDetail",
    component: () => import("./detail/index.vue"),
    meta: {
      title: "订单详情",
      keepHomeLayout: true,
    },
    hidden: true,
  },
];

export default orderDetailRoutes;
